import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {bemTiposModuleName, bemTiposStorage} from "../shared/data.service";
import {BemTipo} from "../shared/bem-tipos.model";
import {Categoria} from "../../categorias/shared/categoria.model";
import {UtilService} from "../../../shared/services/util.service";
import {BemTiposApiService} from "../shared/bem-tipos-api.service";
import {BemTiposService} from "../shared/bem-tipos.service";
import {editRoute, newRoute} from "../../../shared/services/data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {BemTiposNavigationService} from "../shared/bem-tipos-navigation.service";
import {CategoriaApiService} from "../../categorias/shared/categoria-api.service";
import {BemSubtipo} from "../../bem-subtipos/shared/bem-subtipo.model";

@Component({
  selector: 'app-bem-tipos-form',
  template: require('./bem-tipos-form.component.html'),
  styles: [require('./bem-tipos-form.component.css')]
})
export class BemTiposFormComponent implements OnInit {
  bemTiposModule: any = bemTiposModuleName;
  formObject: any = new BemTipo();
  categoriaObject: any = new Categoria();
  actionTitle: string;
  submitted: boolean = false;
  btnSaveDisabled: boolean = false;
  showSelectCategoria: boolean = false;

  categoriasList: Categoria[] = [];
  subtiposList: BemSubtipo[] = [];

  form: FormGroup;
  categoria = new FormControl('', Validators.required);
  tipo = new FormControl('', Validators.required);
  codigoTce = new FormControl('');
  ativo = new FormControl('');

  private returnToOtherForm: boolean = false;
  private otherForm: string;
  private responseBemTipos: any;

  constructor(
    private _route: ActivatedRoute,
    private _bemTiposApiService: BemTiposApiService,
    private _bemTiposService: BemTiposService,
    private _bemTiposNavigationService: BemTiposNavigationService,
    private _utilService: UtilService,
    private _categoriaApiService: CategoriaApiService,
    private _autocompleteService: AutoCompleteService,
    private _fb: FormBuilder
  ) {
    this.form = _fb.group({
      ativo: this.ativo,
      categoria: this.categoria,
      tipo: this.tipo,
      codigoTce: this.codigoTce
    });
  }

  ngOnInit() {
    this.isNewAutoComplete();
  }

  clickGoToList() {
    this.goToList();
  }

  clickCancel() {
    this.toLeaveHere();
  }

  onSubmit(evt: any) {
    this.submitted = true;
    if(evt.valid) {
      this.btnSaveDisabled = true;
      var object: any = this._utilService.cloneObject(this.formObject);

      if (this.categoriaObject.id) {
        object.categoriaId = this.categoriaObject.id;
      } else {
        this.btnSaveDisabled = false;
        return false;
      }

      if (this.subtiposList.length) {
        var subTipos:Array<BemSubtipo> = [],
          x: any, lenX: any;
        for (x = 0, lenX = this.subtiposList.length; x < lenX; x++) {
          if (this.subtiposList[x].subTipo) {
            this.subtiposList[x].codigoTce = object.codigoTce;
            subTipos.push(this.subtiposList[x]);
          }
        }
        object.SubTipos = subTipos;
      }

      if (this.formObject.id) {
        this.onEditBemTipos(object);
      } else {
        this.onAddBemTipos(object);
      }
    }
  }

  private onAddBemTipos(object: BemTipo) {
    this._bemTiposApiService.onPost(object, this.onDone);
  }

  private onEditBemTipos(object: BemTipo) {
    this._bemTiposApiService.onPut(object, this.onDone);
  }

  private onDone = (function (Response: any) {
    if (!Response.error)  {
      this.responseBemTipos = Response;
      if (this.formObject.id) {
        this._utilService.swalMessageEditSuccess();
      } else {
        this._utilService.swalMessageAddSuccess();
      }

      this.toLeaveHere();
    } else {
      this.btnSaveDisabled = false;
      this._utilService.swalMessageWarningCustom(Response.error);
    }
  }.bind(this));

  private getObject(id: number) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.formObject = Response[0];
        this.subtiposList = Response[0].SubTipos;
        this.setModelToForm();
      } else {
        this._utilService.swalMessageWarningCustom('Nenhum tipo de bem encontrado com este id.');
        this.toLeaveHere();
      }
    }.bind(this));

    this._bemTiposApiService.onGetById(id, onDone);
  }

  private testSession() {
    var id: number;
    var session: any = this._bemTiposService.getSessionStorage();
    this._bemTiposService.clearSessionStorage();

    if (session) {
      this.formObject = session;
      id = session.id;
      if (id) {
        this.setEditSession();
      } else {
        this.setNewSession();
      }
    } else {
      id = +this._route.snapshot.params['id'];
      if (id) {
        this.setEditNormal(id);
      } else {
        this.setNewNormal();
      }
    }

    this.setActionTitle(id);
  }

  private setActionTitle(id: number) {
    if (id) {
      this.actionTitle = editRoute;
    } else {
      this.actionTitle = newRoute;
    }
  }

  private setEditNormal(id: number) {
    this.getObject(id);
    this.getCategorias();

    this.showSelectCategoria = true;
  }

  private setNewNormal() {
    //se tiver alguma configuração inicial de um cadastro novo
    this.categoriaObject = this._bemTiposService.getSessionStorageFatherModule();
    this.setModelToForm();
    this.setCodigoTce();
  }

  private setEditSession() {
    //qndo retornou para continuar a edição
    this.getCategorias();
    this.setModelToForm();

    this.showSelectCategoria = true;
  }

  private setNewSession() {
    //qndo retornou para continuar o cadastro
    this.getCategorias();
    this.setModelToForm();
  }

  private isNewAutoComplete() {
    var newAutoComplete: any = this._autocompleteService.getSessionStorage(bemTiposStorage);
    if (newAutoComplete) {
      this.returnToOtherForm = true;
      this.otherForm = newAutoComplete.form;
      this.formObject.tipo = newAutoComplete.tipo;
      this.categoriaObject.id = newAutoComplete.categoriaId;
      this.showSelectCategoria = true;

      this.getCategorias();
      this.setActionTitle(this.formObject.id);
    } else {
      //retornando de um cadastro
      this.testSession();
    }
  }

  private setModelToForm() {
    if (this.formObject.categoria) {
      this.categoriaObject = this.formObject.categoria;
      delete this.formObject['categoria'];

      if (this.categoriasList.length) {
        this.setCategoria();
      }
    }
  }

  private goToList() {
    this._bemTiposNavigationService.goToList();
  }

  private getCategorias() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.categoriasList = Response;
        this.setCategoria();
      }
    }.bind(this));

    this._categoriaApiService.onGetAll(onDone);
  }

  private setCategoria() {
    var x: any, lenX: any;

    // if (this.returnToOtherForm) {
    //   this.categoriaObject = this.categoriasList[0];
    // }

    for (x = 0, lenX = this.categoriasList.length; x < lenX; x++) {
      if (this.categoriasList[x].id === this.categoriaObject.id) {
        this.categoriaObject = this.categoriasList[x];
        break;
      }
    }
    this.setCodigoTce();
  }

  private toLeaveHere() {
    if (this.returnToOtherForm) {
      this._bemTiposService.returnToOtherForm(this.otherForm, this.responseBemTipos);
    } else {
      this.goToList();
    }
  }

  private setCodigoTce() {
    if (!this.formObject.id && !this.formObject.codigoTce) {
      this.formObject.codigoTce = this.categoriaObject.codigoTce;
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-tipos/bem-tipos-form/bem-tipos-form.component.ts
 **/